import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  addPreAlert(context, payload) {
    return axios
      .post("/api/pre-alerts/upload", payload)
      .then((res) => res.data);
  },
  preAlertorderDetails(_, data) {
    return axios
      .get(`/api/pre-alert_shipment_item/list/${data.id}`, {
        params: data.options,
      })
      .then((res) => res.data);
  },
  downloadPreAlertData(_, payload) {
    return axios
      .post(`/api/prealert-manifest-format`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  getPrealertList(context, payload) {
    return axios
      .get("/api/pre-alert_shipment/list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getdateDetails(context, id) {
    return axios
      .get(`/api/pre-alert_arrival_date/view/${id}`)
      .then((res) => res.data);
  },
  updatedateDetails(context, payload) {
    return axios
      .patch(`/api/pre-alert_arrival_date/update/${payload.id}`, payload.data)
      .then((res) => res.data);
  },
  downloadPrealertTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=app_packages/prealert/prealert_template.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  downloadMawbfile(_, url) {
    return axios
      .get(`/api/file_download?file_path=${url}`, {
        responseType: "blob",
      })
      .then((res) => res);
  },

  getBaseAirportCodes() {
    return axios.get("/api/base_airports/list").then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
